import { render, staticRenderFns } from "./FormTerapiaPsicologica.vue?vue&type=template&id=c263f466"
import script from "./FormTerapiaPsicologica.vue?vue&type=script&lang=js"
export * from "./FormTerapiaPsicologica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports